import { useQuery, useQueryClient, useMutation } from 'react-query'
import { getVoiceList } from 'src/services/get/getVoiceList'
import { handleUpdateVoiceFavorite } from 'src/services/post/handleUpdateVoiceFavorite'
import VoiceItem from 'src/models/VoiceItem'
import { characterVoiceList } from 'src/constants/characters'

const useGetVoiceList = (id, page, order) => {
  return useQuery({
    queryKey: ['voiceList', id, page, order],
    queryFn: () => getVoiceList(id, page, order),
    select: (data) => {
      if (!data) return
      return {
        ...data,
        items: data.items.map((item) => {
          const imageUrl = item.thumbnail?.url ? item.thumbnail.url : characterVoiceList.filter(item => item.id === id)[0].default
          return new VoiceItem(
            item.id,
            item.name,
            item.voice_url.url,
            imageUrl,
            item.favorite,
            item.updated_at,
            item.receivedTime,
            item.rarity,
            item.isPlay,
            item.amount
          )
        })
      }
    }
  })
}

const useLikeVoice = (characterID, page, order) => {
  const queryClient = useQueryClient()
  const mutation = useMutation(
    ({ ID, favorite }) => handleUpdateVoiceFavorite(characterID, ID, favorite),
    {
      onError: (error) => {
        console.error(error)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['voiceList', characterID, page, order])
      }
    }
  )
  return mutation
}

export { useGetVoiceList, useLikeVoice }
